// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import cstmTable from '../../../share/components/vue/PaginationTable';
import config from '../../../share/config';
import individualDiagnose from '../../../share/util/individualDiagnose';
import api from '../../../common/api';
import handler from '../../../share/util/apiResultValidator';
import alert from '../../../share/alert';
import loading from '../../../share/components/vue/ProcessingIcon';
import memoPage from '../../vue/MemoPage';
import util from '../../../share/util/utils';
import diagnoResource from '../../../share/util/diagnose';
import resource from '../../../share/util/resourceMap';
import bmdModal from '../../vue/BMDModal';
import logWrapper from '../../../share/logWrapper';
import eventLogUtil from '../../../share/util/eventLogUtil';
import constants from '../../../common/nodejs/constants';
import ApiService from '../../../share/util/api/service';
import { getMeasuredDataName, getCsvFileName } from '../../../util/fileExport';

const VEHICLE_INIT = "init";
const VEHICLE_INFO_GET = "get";
const VEHICLE_MEMORY_CLEAR = "clear";
const PHASE6_MEMORY_CLEAR_FAILED = "phase6_clear_failed";

export default {
  name: "IndividualVehicleControlHistory",
  data() {
    return {
      processing: false,
      bmcSystemTableColumns: [],
      bmcListItems: [],
      // BMD一覧
      bmdTitle: '',
      bmdSystem: '',
      bmdDescription: '',
      bmdSystemTable: [],
      selectedSystem: null,
      // システム間移動判定
      isUseCache: true,
      measuredId: null,
      getVchListResponse: null,
      testModeVisible: false,
      modalBmd: false,
      modalMemo: false,
      isMemoDialogLoading: false,
      protocol: ''
    };
  },

  props: {
    limitedHeightMode: { type: Boolean, required: false, default: false },
    diagApiStatus: { type: Object, required: false, default: () => ({ feature: '', status: '' }) }, // 親コンポーネントから受け取るAPI通信状態
  },

  components: {
    'processing-view': loading,
    'cstm-table': cstmTable,
    'memo-Page': memoPage,
    'bmd-modal': bmdModal
  },

  watch: {
    language: {
      immediate: true,
      handler(val) {
        val; // To avoid warning
        if (!this.getVchListResponse) {
          return;
        }
        this.updateBmcTable(this.getVchListResponse);
      }
    }
  },

  computed: {
    ...mapState({
      language: state => state.systems.language,
      netAppId: state => state.netAppConnector.pairingAppId,
      vehicleInfo: state => state.vehicle.vehicleInfo,
      cachedBMDs: state => state.cache.bmdStores,
      isPopstateNavigation: state => state.cache.isPopstateNavigation,
    }),

    // 診断系のAPIは複数画面から使用されているため
    // 現在の画面で使用されるAPIが診断/データ再生/個別診断のうちどの機能なのか判別する
    operationScreen() {
      return diagnoResource.operationFrom(this.$router.currentRoute.value.name);
    },

    // ボタン非活性フラグ（計測IDが未取得 または ポーリング中）
    isDisabledBtn() {
      return !this.measuredId || this.diagApiStatus.status === 'polling';
    }
  },

  // 遷移してきた画面のパラメータ情報を保持
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 遷移してきたときのコンポーネント内ガード共通処理
      vm.beforeRouteProcess(vm, from);
    });
  },

  /**
   * 遷移してきた画面のパラメータ情報を保持
   * 同一コンポーネントが再帰的に利用された場合、呼び出される
   */
  beforeRouteUpdate(to, from, next) {
    if (this.isPopstateNavigation) {
      this.cacheIsPopstateNavigation(false);
      next();
      return;
    }
    this.$nextTick(() => {
      // 遷移してきたときのコンポーネント内ガード共通処理
      this.beforeRouteProcess(this, from);
      // テーブル情報クリア（本当は mountedLogic に入れたいが、影響範囲を考慮してここにピンポイントで入れている）
      // BMD キャッシュクリアは、moutedLogic 内でやっているので問題なし
      this.bmcListItems = [];
      // mounted時に行う共通処理を呼び出す
      this.mountedLogic();
    });
    next();
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),
    ...mapActions('cache', ['cacheBmdStores', 'cacheIsPopstateNavigation']),
    ...mapActions('observation', ['usageCountUp']),

    /**
     * componentのmounted時に呼び出す処理
     */
    mountedLogic() {
      // BMDのキャッシュクリア
      this.cacheBmdStores([]);
      // BMCテーブルの取得
      this.init();

      // debug 環境のみ実施有効とする
      if (process.env.VUE_APP_DEBUG_LOG) {
        // テストボタン表示 
        document.onkeydown = (event) => {
          if (event) {
            // Ctrl+Shift+V key detection
            if (event.shiftKey && event.ctrlKey) {
              if (event.code === "KeyV") {
                this.testModeVisible = true;
                return true;
              }
            }
          }
          return util.checkSSM5ValidCharacters(event);
        };
      }
    },

    /**
     * メモダイアログを表示
     */
    openNoteModal() {
      this.modalMemo = true;
    },

    /**
     * メモダイアログを閉じる
     */
    closeNoteModal() {
      this.modalMemo = false;
    },

    /**
     * メモ情報の保存
     */
    async memoSave() {
      await this.$refs.memo.save();
    },

    /**
     * メモ情報のクリア
     */
    memoClear: function () {
      this.$refs.memo.clear();
    },

    /**
     * 再取得ボタン押下時の処理
     */
    regetBmc() {
      const messages = this.$t('individual.message_vehicle_bmc_confirm_get_information');
      alert.showConfirmation(this, null,
        messages,
        async () => {
          // BMDのキャッシュクリア
          this.cacheBmdStores([]);
          // 制御作動履歴の取得
          this.getBmc(true);
        });
    },

    /**
       * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     * @param {string} action 処理内容
     */
    validateErrorResult(result, action) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(action); },
      );
    },

    /**
     * BMCテーブル情報の更新を行う
     */
    async init() {
      try {
        // 初期化通信の実行
        this.processing = true;
        const systemId = individualDiagnose.getCurrentSystemId(this);
        // イベントログの操作 ID 発行
        await eventLogUtil.createEventLogHandleId(this.netAppId);
        // 初期化(要求)（バックエンドAPI_POST）
        const response = await individualDiagnose.pollingApi(
          this,
          // POST API 呼び出しのコールバック
          async () => {
            return await api.postCall(
              config.VCH,
              '/netApps/' + this.netAppId + '/systems/' + systemId + '/initialize',
              {
                use_cache: this.isUseCache
              }
            );
          },
          // GET API 呼び出しのコールバック
          async (postApiResponse) => {
            return await api.getCall(
              config.VCH,
              '/netApps/' + this.netAppId + '/systems/' + systemId + '/vehicleControlHistories/requests/' + postApiResponse.data.request_id
            );
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(VEHICLE_INIT); },
          // POST API レスポンスチェックのコールバック
          (postApiResponse) => {
            // リクエストID が正常に返ってきたら成功とする
            return postApiResponse && postApiResponse.data && postApiResponse.data.request_id ? '' : config.INDIVIDUAL_API_CALL_ERROR_POST_INVALID_RESPONSE;
          },
          // GET API レスポンスチェックのコールバック
          (getApiResponse) => {
            let result = config.INDIVIDUAL_POLLING_RESULT_ERROR;
            if (getApiResponse && getApiResponse.data && getApiResponse.data.status) {
              switch (getApiResponse.data.status) {
                case config.STATUS_VCH_COMPLETED:
                  // ポーリング終了を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                  break;
                case config.STATUS_VCH_IN_PROGRESS:
                  // ポーリング続行を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_CONTINUE;
                  break;
                case config.STATUS_VCH_FAILED:
                default:
                  // それ以外はエラー発生を返す
                  break;
              }
            }
            return result;
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, VEHICLE_INIT); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, VEHICLE_INIT); },
        );

        if (response) {
          // 正常終了：ダイアグコードの取得を行う
          await this.getBmc();
        }
      } finally {
        this.processing = false;
      }
    },

    /**
     * 制御作動履歴の取得を行う関数
     * @param {boolean} eventLogHandleIdFlg 再取得から呼ばれた際に true（イベントログの操作 ID 発行する）とする
     */
    async getBmc(eventLogHandleIdFlg = false) {
      try {
        this.processing = true;
        const systemId = individualDiagnose.getCurrentSystemId(this);
        if (eventLogHandleIdFlg) {
          // イベントログの操作 ID 発行
          await eventLogUtil.createEventLogHandleId(this.netAppId);
        }
        // 制御作動履歴の取得(要求)（バックエンドAPI_POST）       
        const response = await individualDiagnose.pollingApi(
          this,
          // POST API 呼び出しのコールバック
          async () => {
            return await api.postCall(
              config.VCH,
              '/netApps/' + this.netAppId + '/systems/' + systemId + '/vehicleControlHistories', {}
            );
          },
          // GET API 呼び出しのコールバック
          async (postApiResponse) => {
            return await api.getCall(
              config.VCH,
              '/netApps/' + this.netAppId + '/systems/' + systemId + '/vehicleControlHistories/requests/' + postApiResponse.data.request_id
            );
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(VEHICLE_INFO_GET); },
          // POST API レスポンスチェックのコールバック
          (postApiResponse) => {
            // リクエストID が正常に返ってきたら成功とする
            return postApiResponse && postApiResponse.data && postApiResponse.data.request_id ? '' : config.INDIVIDUAL_API_CALL_ERROR_POST_INVALID_RESPONSE;
          },
          // GET API レスポンスチェックのコールバック
          (getApiResponse) => {
            let result = config.INDIVIDUAL_POLLING_RESULT_ERROR;
            if (getApiResponse && getApiResponse.data && getApiResponse.data.status) {
              switch (getApiResponse.data.status) {
                case config.STATUS_VCH_COMPLETED:
                  // ポーリング終了を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                  break;
                case config.STATUS_VCH_IN_PROGRESS:
                  // ポーリング続行を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_CONTINUE;
                  break;
                case config.STATUS_VCH_FAILED:
                default:
                  // それ以外はエラー発生を返す
                  break;
              }
            }
            return result;
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, VEHICLE_INFO_GET); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, VEHICLE_INFO_GET); },
        );

        if (response) {
          // 正常終了：一覧データ取得処理を行う
          this.measuredId = String(response.data.measured_id);
          this.getVchListResponse = await this.getVchList();
          // responseが存在しない場合、処理終了
          if (!this.getVchListResponse) {
            return;
          }
          // 先頭から取得する。BMCがない場合もプロトコルは取得される。
          this.protocol = this.getVchListResponse.data[0]?.protocol_type;
          // BMCテーブルの更新
          this.updateBmcTable();
          // 制御作動履歴の利用回数カウントアップ
          this.usageCountUp({ type: config.USAGE_COUNT_VCH, systemName: systemId });
        }
      } finally {
        this.processing = false;
      }
    },

    /**
     * Getのレスポンスのハンドリングを行う
     * @param response GetのResponse
     * @param currentRetry リトライ回数
     * @param retryMaxCount 最大リトライ可能回数
     * @param action 処理内容
     * @returns 処理結果{isCompleted: 終了判定(boolean), response: GetのResponse | null}
     */
    async getResponseHandler(response, currentRetry, retryMaxCount, action) {
      return new Promise((resolve) => {
        handler.validate(handler.validateTypes.all, response, this, null, () => {
          // 正常コールバック
          switch (response.data.status) {
            // 正常終了、異常終了
            case config.STATUS_VCH_COMPLETED:
            case config.STATUS_VCH_FAILED:
              return resolve({ isCompleted: true, response: response });
            default:
              // in_progress
              if (currentRetry >= retryMaxCount) {
                // リトライ回数上限値に達した場合も処理終了
                // 汎用エラー扱いの為、responseをnullで返す
                this.showUnexpectedError(action);
                return resolve({ isCompleted: true, response: null });
              }
              return resolve({ isCompleted: false, response: null });
          }
        },
          (result) => {
            // 不正応答コールバックが呼び出された場合も処理終了
            const cause = result.causeType;
            const behaviorType = result.behaviorType;
            // セッションが不正・ネットワークエラーならログアウト処理を行う(CC通信は行っていないのでCCエラーは対象外)
            if (cause === handler.causeTypes.networkError ||
              cause === handler.causeTypes.invalidSessionToken) {
              alert.showWarning(this, null, result.message, () => {
                if (behaviorType === handler.behaviorTypes.logout) {
                  this.logout(this);
                } else if (behaviorType === handler.behaviorTypes.resetSession) {
                  this.resetSession(this);
                }
              });
            } else {
              // その他のエラー
              this.showUnexpectedError(action);
            }
            // エラー扱いの為、responseをnullで返す
            resolve({ isCompleted: true, response: null });
            return;
          }, null, false);
      });
    },

    /**
     * 一覧取得処理を行う関数
     * @returns GetのResponse | null
     */
    async getVchList() {
      try {
        this.processing = true;
        const projectId = this.vehicleInfo.vehicle.project.id;

        const response = await individualDiagnose.syncApi(
          this,
          // Get APIを呼び出す
          async () => {
            return await api.getCall(
              config.VCH,
              '/vehicleControlHistories/' + projectId + '/' + this.measuredId,
              this.operationScreen
            );
          },
          // エラー発生のコールバックを実装する。
          (errorType) => { errorType; this.showUnexpectedError(VEHICLE_INFO_GET); },
          // GET API で正常レスポンスが返ってきた際の内容チェックを実装する。
          (getApiResponse) => {
            // menus が入っていれば成功とする
            return getApiResponse && getApiResponse.data && getApiResponse.data.project ? '' : config.INDIVIDUAL_API_CALL_ERROR_GET_INVALID_RESPONSE;
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result, VEHICLE_INFO_GET); },
        );
        // 処理失敗時は response が null になるので考慮
        return response ? response.data.project : null;
      } finally {
        this.processing = false;
      }
    },

    /**
     * BMCテーブルの更新
     */
    updateBmcTable() {
      // BMCテーブルカラムの作成
      const igonCntVar = util.mkHeaderValue(this.getVchListResponse.current_igon_time);
      const igonCnt = this.$t('message.header_vehicle_dtc_table_igon_counts');
      const igonCounterValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igonCntVar;
      const igonTimeVar = util.mkHeaderValue(this.getVchListResponse.current_igon_mill_sec);
      const igonTime = this.$t('message.header_vehicle_dtc_table_igon_times');
      const igonTimeValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igonTimeVar;
      this.bmcSystemTableColumns = [
        // Phase5のみステータス列を表示する（空で表示される）
        ...(this.protocol === config.PROTOCOL_PHASE5 ? [{ name: 'status', label: 'message.header_vehicle_dtc_table_status', useResource: true }] : []),
        { name: 'bmc', label: 'message.header_vehicle_dtc_table_code' },
        { name: 'description', label: 'message.header_vehicle_dtc_table_description', useResource: true, originalSortFunc: diagnoResource.sortFuncDescription },
        { name: 'igonCount', label: util.setColums(igonCnt, igonCounterValue, "{0} {1}", true), useHtmlBind: true, originalSortFunc: diagnoResource.sortIgon },
        { name: 'igonTime', label: util.setColums(igonTime, igonTimeValue, "{0} {1}", true), useHtmlBind: true, originalSortFunc: diagnoResource.sortIgon },
        { name: 'counterType', label: 'message.header_vehicle_dtc_table_type' },
        { name: 'bmd', label: 'individual.header_vehicle_bmc_table_bmd', useButton: true, useResource: true, originalSortFunc: diagnoResource.sortFuncFfd },
      ];

      // BMCテーブルの更新
      let bmcList = [];
      switch (this.getVchListResponse.res_type) {
        // 正常
        case config.VCH_RESPONSE_TYPE_OK:
          // 取得データでBMCテーブルを設定
          bmcList = bmcList.concat(resource.createBmcTable(this.getVchListResponse.data, this));
          break;
        // 異常、取得なし
        case config.VCH_RESPONSE_TYPE_NG:
        case config.VCH_RESPONSE_TYPE_NO:
          // 空の BMC を表すテーブルアイテムを作成（通信不能）
          bmcList = bmcList.concat(resource.createEmptyBmcTableItem(config.BMC_STATUS_CANNOT_CONNECT));
          break;
        default:
      }
      this.bmcListItems = bmcList;
    },

    /** DTC 計測中警告ダイアログ */
    inExecutionAlert() {
      alert.showWarning(
        this,
        null,
        this.$t("individual.alert_diag_code_measurement"),
        () => { }
      );
    },

    /**
     * BMDボタン押下時の処理
     * @param {*} data 選択されたデータ
     */
    async clickBMD(data) {
      if (!data) return;
      // 統合画面で DTC ポーリング中は BMD 表示をブロック
      if (this.diagApiStatus.status === 'polling') {
        this.inExecutionAlert();
        return;
      }
      // タイトルの設定
      this.bmdTitle = data.bmc;
      this.bmdSystem = this.$t(data.name);
      this.bmdDescription = this.$t(data.description);

      const cache = this.cachedBMDs.filter(e => e.system === data.systemID && e.bmc === data.bmc);
      if (cache.length > 0) {
        // キャッシュ有りなら キャッシュ済みデータを表示
        this.bmdSystemTable = cache[0].data;
        this.selectedSystem = data;
        this.modalBmd = true;
        return;
      }
      // キャッシュ無しなら BMD一覧情報を取得
      // BMD取得時はオリジナルのBMCを送る
      const bmdResponse = await this.getBmdResponse(data.originalBmc, data.systemID);
      // responseが存在しない場合、処理終了
      if (!bmdResponse) {
        return;
      }
      // キャッシュの更新
      this.cacheBmdStores([...this.cachedBMDs, { system: data.systemID, bmc: data.bmc, data: bmdResponse }]);

      // BMDダイアログの表示
      this.bmdSystemTable = bmdResponse;
      this.selectedSystem = data;
      this.modalBmd = true;
    },

    /**
     * BMD一覧情報取得を行う関数
     * @param {*} bmc 選択したbmc
     * @param {*} systemId systemId
     */
    async getBmdResponse(bmc, systemId) {
      try {
        this.processing = true;
        const projectId = this.vehicleInfo.vehicle.project.id;
        // Get APIを呼び出す
        const response = await individualDiagnose.syncApi(
          this,
          async () => {
            return await api.getCall(
              config.VCH,
              '/vehicleControlHistories/' + projectId + '/' + this.measuredId + '/bmd/systems/' + systemId + '/codes/' + bmc,
              this.operationScreen
            );
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(VEHICLE_INFO_GET); },
          // GET API で正常レスポンスが返ってきた際の内容チェック
          (getApiResponse) => {
            // data が入っていれば成功とする
            return getApiResponse && getApiResponse.data && getApiResponse.data.data ? '' : config.INDIVIDUAL_API_CALL_ERROR_GET_INVALID_RESPONSE;
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result, VEHICLE_INFO_GET); },
        );
        // 処理失敗時は response が null になるので考慮
        return response ? response.data.data : null;
      } finally {
        this.processing = false;
      }
    },

    /**
     * 制御作動履歴消去ボタン押下時の処理
     */
    deleteBmc() {
      const messages = this.$t('individual.message_confirm_vch_delete');
      // 削除確認ダイアログを表示
      alert.showConfirmation(this, null, messages,
        async () => {
          this.cacheBmdStores([]);
          await this.clearVchRequest();
        });
    },

    /**
     * 車両制御履歴クリアのリクエストを送る
     */
    async clearVchRequest() {
      try {
        let protocol = '';
        this.processing = true;
        const systemId = individualDiagnose.getCurrentSystemId(this);
        // 消去結果フラグ
        let resultFlag = false;
        // イベントログの操作 ID 発行
        await eventLogUtil.createEventLogHandleId(this.netAppId);
        const response = await individualDiagnose.pollingApi(
          this,
          // POST API 呼び出しのコールバック
          async () => {
            return await api.postCall(
              config.VCH,
              `/netApps/${this.netAppId}/systems/${systemId}/vehicleControlHistories/clear`, {}
            );
          },
          // GET API 呼び出しのコールバック
          async (postApiResponse) => {
            protocol = postApiResponse.data.protocol;
            return await api.getCall(
              config.VCH,
              '/netApps/' + this.netAppId + '/systems/' + systemId + '/vehicleControlHistories/requests/' + postApiResponse.data.request_id
            );
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(VEHICLE_MEMORY_CLEAR); },
          // POST API レスポンスチェックのコールバック
          (postApiResponse) => {
            // リクエストID が正常に返ってきたら成功とする
            return postApiResponse && postApiResponse.data && postApiResponse.data.request_id ? '' : config.INDIVIDUAL_API_CALL_ERROR_POST_INVALID_RESPONSE;
          },
          // GET API レスポンスチェックのコールバック
          (getApiResponse) => {
            let result = config.INDIVIDUAL_POLLING_RESULT_ERROR;
            if (getApiResponse && getApiResponse.data && getApiResponse.data.status) {
              switch (getApiResponse.data.status) {
                case config.STATUS_VCH_COMPLETED:
                  // ポーリング終了を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                  break;
                case config.STATUS_VCH_IN_PROGRESS:
                  // ポーリング続行を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_CONTINUE;
                  break;
                case config.STATUS_VCH_FAILED:
                default:
                  // それ以外はエラー発生を返す
                  break;
              }
            }
            return result;
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, VEHICLE_MEMORY_CLEAR); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, VEHICLE_MEMORY_CLEAR); },
        );

        if (response) {
          // 正常終了
          resultFlag = true;
        }
        // 削除結果の表示を行う
        this.resultMemoryClear(resultFlag, protocol);
      } finally {
        this.processing = false;
      }
    },

    /**
     * 車両制御履歴削除の結果画面の表示
     * @param {boolean} 消去成功/失敗フラグ
     * @param {string} 削除対象のプロトコル
     */
    resultMemoryClear(resultFlag, protocol) {
      // プロトコルがPhase6かつ消去に失敗していた場合、共通エラーダイアログを表示する
      if (protocol === constants.PROTOCOL_Phase6 && !resultFlag) {
        this.showUnexpectedError(PHASE6_MEMORY_CLEAR_FAILED);
        return;
      }
      let messages = null;
      const removeOperation = '<span style="color: red; font-size: 16px;">' + this.$t('message.message_vehicle_dtc_complete_remove_dtc_operation') + '</span>';
      const removeFooter = this.$t('individual.message_info_vehicle_bmc_re_get');

      if (resultFlag) {
        // 消去成功メッセージ
        const removeHeader = this.$t('individual.message_complete_vch_delete');
        messages = ('{0}\r\n\r\n{1}\r\n\r\n{2}').format(removeHeader, removeOperation, removeFooter);
      } else {
        // 消去失敗メッセージ
        const removeFailure = this.$t('individual.error_failed_vch_delete');
        messages = ('{0}\r\n\r\n{1}\r\n\r\n{2}').format(removeFailure, removeOperation, removeFooter);
      }

      alert.showInfo(this, null,
        messages,
        async () => {
          // Bmcデータの再取得
          this.getBmc();
        });
    },

    /**
     * その他のエラー発生時の処理を行う
     * @param {string} action 処理内容
     */
    showUnexpectedError(action) {
      let messageKey;
      switch (action) {
        case VEHICLE_INIT:
          messageKey = 'individual.error_Initialize_communication_error';
          break;
        case VEHICLE_INFO_GET:
          messageKey = 'individual.error_failed_vch_get';
          break;
        case VEHICLE_MEMORY_CLEAR:
          messageKey = 'individual.error_failed_vch_delete';
          break;
        case PHASE6_MEMORY_CLEAR_FAILED:
          messageKey = 'individual.error_communication_error';
          break;
      }
      alert.showError(this, null, this.$t(messageKey), () => { });
    },

    /**
     *BMC情報をCSVエクスポートする
     */
    async csvExport() {
      const fileInfo = {};
      let resultInfo = {};
      // 行のフォーマット
      resultInfo = this.bmcListItems.map(item => {
        return {
          ...item,
          status: this.$t(item.status),
          description: this.$t(item.description),
          bmd: item.buttonVisible ? this.$t('message.available_bmd') : this.$t('message.no_bmd')
        };
      });

      // 列のフォーマット
      const igOnCntVar = util.mkHeaderValue(this.getVchListResponse.current_igon_time);
      const igOnCnt = this.$t('message.header_vehicle_dtc_table_igon_counts');
      const igOnCounterValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igOnCntVar;
      const igOnTimeVar = util.mkHeaderValue(this.getVchListResponse.current_igon_mill_sec);
      const igOnTime = this.$t('message.header_vehicle_dtc_table_igon_times');
      const igOnTimeValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igOnTimeVar;

      fileInfo.column = this.bmcSystemTableColumns.map(column => {
        if (column.name === 'igonCount') {
          column.label = igOnCnt + " " + igOnCounterValue;
        } else if (column.name === 'igonTime') {
          column.label = igOnTime + " " + igOnTimeValue;
        }
        return column;
      });

      // VINデータのフォーマット
      const vinHeader = `"${this.$t('message.label_measured_data_search_vin')}","${this.vehicleInfo.vehicle.vin.vin}"\n`;

      // 出力形式の設定
      const headers = fileInfo.column.map(column => {
        if (column.name === 'igonCount' || column.name === 'igonTime') {
          return { id: column.name, title: column.label };
        } else {
          return { id: column.name, title: this.$t(column.label) };
        }
      });

      // 説明・故障部位のエスケープ処理
      fileInfo.record = util.escapeDoubleQuotation(resultInfo, 'description');

      let endPoint = '';
      let measuredDataName = '';

      if (this.vehicleInfo.vehicle.project.id !== null && this.measuredId !== null) {
        try {
          this.processing = true;
          // プロジェクトIDおよび計測データIDが存在する場合、計測データ取得APIを指定
          endPoint = '/projects/' + this.vehicleInfo.vehicle.project.id + '/' + this.measuredId;
          // 計測データ名を取得
          measuredDataName = await getMeasuredDataName(this, ApiService.VCH, endPoint, this.operationScreen);
        } finally {
          this.processing = false;
        }
      }
      const fileName = getCsvFileName(this.$t('individual.individual_diagnosis_function_vehicle_control_history'), measuredDataName, this.vehicleInfo.vehicle.vin.vin);

      // CSVファイルエクスポート処理
      const data = vinHeader + util.createCsvData(headers, fileInfo.record);

      // CSVファイルエクスポート処理
      util.csvFileExport(data, fileName);
    },

    /* Start テスト用の関数一覧 */
    /**
     * BMCのテストデータを出力する
     */
    bmcTestDataExport() {
      // テストdataを生成する
      const test = { info: [] };
      this.getVchListResponse.data.forEach(element => {
        // BMCコードが設定されているもののみテスト用で出力する。 
        if (element.code) {
          const resourceId = this.removeResourceKey(resource.getBmcDescriptionResource(element, this));
          const testData = {
            system: element.system,
            code: element.code,
            resource_id: resourceId
          };
          test.info.push(testData);
        }
      });
      if (test.info.length > 0) {
        const systemName = test.info[0].system;
        const blob = new Blob([JSON.stringify(test, null, '  ')], {
          type: 'application/json',
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = ('{0}_BMC_FRONT.json').format(systemName); // 出力するファイルの名前
        link.click();
        link.remove();
      }
    },

    /**
     * DIDのテストデータを出力する
     */
    didTestDataExport() {
      const bmd = this.$refs.bmd_modal.getTestData();
      const test = this.createBMDTestData(this.bmdSystemTable, bmd.items);
      // テストdataを生成する
      // 独自のsortIDでソート
      test.info.sort((a, b) => {
        if (a.sortId < b.sortId) return -1;
        if (a.sortId > b.sortId) return 1;
        return 0;
      });
      // データモニター表示順でソート
      test.info.sort((a, b) => {
        if (a.monitor_order < b.monitor_order) return -1;
        if (a.monitor_order > b.monitor_order) return 1;
        return 0;
      });
      // 独自のsortID削除
      test.info.forEach(element => {
        delete element.sortId;
      });

      if (test.info.length > 0) {
        const systemName = this.removeResourceKey(this.selectedSystem.name);
        const csvArray = [[], [], []];
        bmd.items.forEach(bmdData => {
          csvArray[0].push(this.$t(bmdData.item));
          csvArray[1].push(this.$t(bmdData.unit));
          csvArray[2].push(bmdData[0]);
        });

        let csvData = '';
        csvArray.forEach(a => {
          const row = a.join(',');
          csvData += row + '\r\n';
        });
        const bomFormatData = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM
        const csvBlob = new Blob([bomFormatData, csvData],
          {
            type: 'text/csv;charset=utf-8',
          });
        const csvLink = document.createElement('a');
        csvLink.href = URL.createObjectURL(csvBlob);
        csvLink.download = ('{0}_DID_FRONT.csv').format(systemName); // 出力するファイルの名前
        csvLink.click();
        csvLink.remove();

        const blob = new Blob([JSON.stringify(test, null, '  ')], {
          type: 'application/json',
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = ('{0}_DID_FRONT.json').format(systemName); // 出力するファイルの名前
        link.click();
        link.remove();
      }
    },

    createBMDTestData(originalData, tableData) {
      const result = { info: [] };

      // 取得したデータを bmd_save_order で振り分ける
      const groupBySystem = util.groupBy(originalData, 'bmd_save_order');
      // 優先して最新(確定)のデータのみ取得する。
      let currentData = null;
      if (util.isKeyExists(groupBySystem, '0')) {
        currentData = groupBySystem['0'];
      } else {
        currentData = groupBySystem['1'];
      }

      if (currentData) {
        tableData.forEach(element => {
          const keyId = this.removeResourceKey(element.item);
          const index = currentData.findIndex(item => item.id === keyId);
          if (index === -1) {
            logWrapper.log('ID not found in current data.', keyId);
          }
          else {
            let keyIndex = 0;
            // 10個のキー名までチェックする。            
            for (let index = 0; index < 10; index++) {
              keyIndex = String(index);
              if (util.isKeyExists(element, keyIndex)) {
                // keyが存在した場合は処理終了
                break;
              }
            }
            const valueKey = 'value_' + keyIndex;
            const resouceIdKey = 'resouceId_' + keyIndex;

            // テストデータは検出時のみを取得する。 
            const findData = currentData[index];

            let sortId = "";
            const keyUnderSplit = keyId.split('_');
            if (keyUnderSplit.length > 1) {
              const second = keyUnderSplit[1].padStart(2, '0');
              sortId = keyUnderSplit[0] + '_' + second;
            }
            if (keyUnderSplit.length > 2) {
              const covertNumber = Number(keyUnderSplit[2]);
              if (!isNaN(covertNumber)) {
                const therd = keyUnderSplit[2].padStart(covertNumber, '0');
                sortId = sortId + '_' + therd;
              }
            }

            const testData = {
              id: keyId,
              sortId: sortId,
              unit: this.removeResourceKey(element.unit),
              digits_after_decimal: findData.digits_after_decimal,
              data_type: findData.data_type,
              value: String(this.roundValue(element[valueKey])),
              value_resouce_id: this.removeResourceKey(element[resouceIdKey]),
              monitor_order: findData.monitor_order
            };
            result.info.push(testData);
          }
        });
      }
      return result;
    },

    /**
     * リソースIDを整形する
     * @param {string} resouceId 
     * @returns 削除結果 
     */
    removeResourceKey(resouceId) {
      let result = "";
      // 設定されていない場合は""文字列で戻す
      if (!resouceId) {
        return result;
      }
      const resouces = resouceId.split('.');
      if (resouces.length > 0) {
        result = resouces[1];
      }
      return result;
    },

    /**
     * 値を10桁に丸める
     * @param {number} value 
     * @returns 結果
     */
    roundValue(value) {
      let result = value;
      if (value) {
        if ((typeof value) === "number") {
          result = value.toFixed(10);
        }
      }
      return result;
    },

    /* End テスト用の関数一覧 */

    /**
     * 呼び出し時のコンポーネント内ガードの共通処理
     * @param vm 呼び出し元のオブジェクト(this)
     * @param from 遷移元 
     */
    beforeRouteProcess(vm, from) {
      if (util.isFromSettingsPage(from.name) || util.isSameSystemPage(from)) {
        // 単位設定画面またはパスワード変更画面からの遷移時、または同じシステム内の子機能間への遷移の場合 trueを指定
        vm.isUseCache = true;
      } else {
        // 上記以外の場合、falseを指定
        vm.isUseCache = false;
      }
    }
  },

  /**
   * createdイベント
   */
  created() {
    // イベントログのページビューカウント
    // 統合画面（IndividualDtcVch）の場合は統合画面でカウントされる。個別VCH画面の場合のみカウント実行
    if (!this.limitedHeightMode) {
      eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_INDIVIDUAL_VCH);
    }
  },

  /**
   * mountedイベント
   */
  mounted() {
    this.mountedLogic();
  },

  beforeUnmount() {
    // debug 環境のみ実施有効とする
    if (process.env.VUE_APP_DEBUG_LOG) {
      // onkeydown の再登録
      document.onkeydown = (event) => {
        return util.checkSSM5ValidCharacters(event);
      };
    }
  }
};